<template>
  <v-text-field
    v-model="valueDisplay"
    hide-details="auto"
    :label="label"
    @input="onInput"
    @blur="onBlur"
    @focus="onFocus"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  emits: ['input'],
  data: () => ({
    valueDisplay: '',
  }),
  watch: {
    value: {
      handler(val) {
        this.valueDisplay = this.formatWithApos(val);
      },
      immediate: true,
    },
  },
  methods: {
    onInput(val) {
      // strip out everything except digits (and dot, if you like)
      const clean = val.replace(/[^0-9.]/g, '');
      this.$emit('input', clean);
      this.valueDisplay = this.formatWithApos(clean);
    },
    // when the field loses focus, ensure it's formatted
    onBlur() {
      this.valueDisplay = this.formatWithApos(this.value);
    },
    // when they focus again, you can show the un-masked number if you prefer:
    onFocus() {
      this.valueDisplay = this.value;
    },
    formatWithApos(digits) {
      // split integer & decimal part
      const [intPart, decPart] = digits.split('.');
      // inject apostrophes every three digits
      const withApos = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '\'');

      return decPart != null
        ? `${withApos}.${decPart}`
        : withApos;
    },
  },
};
</script>
